import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";
import redirectTo404 from "utils/redirectTo404";

/**
 * Query blog post
 */
export default async function queryBlog(
  url: string,
  shouldRedirectOn404 = false,
): Promise<Blog> {
  const response = await fetchOrchidAPI(`/api/blog/v1/blog_entry/url/${url}`);
  if (!response.ok) {
    if (shouldRedirectOn404 && response.status === 404) {
      redirectTo404();
    }
    throw new Error(
      `failed to get blog post: ${getErrorDetail(await response.text())}`,
    );
  }

  return response.json();
}
